import { defineStore } from 'pinia'
import { IStore } from '@/contracts/modules/note/stores/IStore'

export default defineStore('modulesNoteV1', {
  state: (): IStore => {
    return {
      notes: {},
      previews: [],
      openTabs: [],
      activeTab: null,
      pendingTabs: [],
      isOpenDialogShown: false,
      files: {},
      transfers: [],
    }
  },
})
